import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.HasJobBeenDoneYet = {
  buttonLayout: function() {
    return 'leftOnlyButton'
  },

  component: React.createClass({
    getInitialState: function() {
      const closureSurvey = Job.Data.closureSurvey;

      return {
        trigger: 'job_modal',
        outcome: closureSurvey.outcome
      }
    },

    componentDidMount: function() {
      Job.Actions.updateAdditionalQuestion(true)
      $('#outcome-radio-group').radioButtonGroup({activeRowClass: 'active'})
    },

    autoProgress: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
      const providerAccountId = Job.Data.closureSurvey.providerAccountId
      Job.Data.closureSurvey.outcome = $selectedItem.value
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.WhoDidTheJob)
    },

    submitCancelledJob: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]

      Job.Actions.updateClosureSurvey({
        job: Job.Data.closureSurvey.job,
        possibleBusinesses: Job.Data.closureSurvey.possibleBusinesses,
        outcome: $selectedItem.value,
        providerAccountId: null,
        providerAccountName: null,
        rating: null,
        comments: null,
        selectedReasons: []
      })

      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SubmitFeedback)
    },

    handleOutcomeRadioClick: function() {
    },

    render: function() {
      let description = Job.Data.closureSurvey.job.description.split('\n').map(i => { return <p style={{'word-break': 'break-all'}}>{i}</p> })
      return (
        <div>
          <h3>{`While you're here, can we ask for an update on your ${Job.Data.closureSurvey.job.suburb_record_name} ${Job.Data.closureSurvey.job.subcategory_name} job from ${Job.Data.closureSurvey.job.created_at}?`}</h3>
          <div className="mt10 mb20 bg-gray-2 radius-6 p16 border">
            {description}
          </div>
          <div className="form-group pb20" onClick={this.handleOutcomeRadioClick}>
            <h3 className="mb15 mt10">Has your job been done yet?</h3>
            <div className="radio-button-box minor-bold" id="outcome-radio-group">
              <div className={"radio " + ((this.state.outcome === "job_completed") ? "active" : "")} onClick={this.autoProgress}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 this-week">Yes</div>
                  <input type="radio" defaultChecked={(this.state.outcome === "job_completed") ? 'checked' : ''} id="job_completed" name="outcome" value="job_completed" className="form-control invisible"/>
                </div>
              </div>
              <div className={"radio " + ((this.state.outcome === "going_ahead") ? "active" : "")} onClick={this.autoProgress}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">Not yet!</div>
                  <input type="radio"  defaultChecked={(this.state.outcome === "going_ahead") ? 'checked' : ''} id="going_ahead" name="outcome" value="going_ahead" className="form-control invisible"/>
                </div>
              </div>
              { (this.state.trigger !== "hire_button" && this.state.trigger !== "leave_feedback_button") &&
                <div className={"radio " + ((this.state.outcome === "not_going_ahead") ? "active" : "")} onClick={this.submitCancelledJob}>
                  <div className="row">
                    <div className="col-xs-10 col-sm-10 asap-urgent">No, I cancelled the job</div>
                    <input type="radio" defaultChecked={(this.state.outcome === "not_going_ahead") ? 'checked' : ''} id="not_going_ahead" name="outcome" value="not_going_ahead" className="form-control invisible"/>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      )
    }
  })
}
